<div class="banner-background" [ngStyle]="backgroundImageStyle()">
  <div class="banner-container py-8 lg:pt-10 lg:pb-0">
    <h1
      class="banner-title"
      [innerHTML]="'redeem_cash_v2.checkout.banner.title' | translate"></h1>
    <p class="banner-subtitle" *ngIf="redeemCashLoyaltyProgram">
      {{
        'redeem_cash_v2.checkout.banner.sub_title'
          | translate
            : {
                cash:
                  redeemCashLoyaltyProgram.transferRate.denomination *
                  redeemCashLoyaltyProgram.transferRate.exchangeRate,
                points:
                  redeemCashLoyaltyProgram.transferRate.denomination
                  | localizePointsNumber
              }
      }}
    </p>
  </div>
</div>
